module.exports = __webpack_public_path__ + "img/purim-2016.7397d62c.jpg";